import utils from "@/composables/utils";
import BaseModel from "./BaseModel";
import LessonAnswer from "./LessonAnswer";

/**
 * Lesson
 */
export default class Lesson extends BaseModel{

  constructor({
    id,
    course_module_video,
    question,
    description,
    multipleChoices,
    created_at,
    updated_at,
    deleted_at,
    answer
  }) {
    super();
    
    this.id = id || null;
    this.course_module_video = course_module_video || null;
    this.question = question || null;
    this.description = description || null;
    this.multipleChoices = multipleChoices || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.deleted_at = deleted_at || null;
    this.answer = answer || null;

    if (this.answer)
      this.handleAnswer();
  }

  /**
   * Returns if this Lesson has 'answer' attr
   * @returns {boolean}
   */
  hasAnswers() {
    return Array.isArray(this.answer) && this.answer.length > 0 ? true : false;
  }

  /**
   * Parses this.answer to LessonAnswer object
   */
  handleAnswer() {
    if (Array.isArray(this.answer)) {

      let lessonAnswerArr = [];
      let index = 0;
      for (let answer of this.answer) {
        answer['index'] = utils.getAlphabetLetter(index);
        lessonAnswerArr.push(new LessonAnswer(answer));
        index++;
      }

      this.answer = lessonAnswerArr;
    }
  }

  /**
   * Gets all LessonAnswers which are correct
   * @return {Object}
   */
  getCorrectAnswers() {
    if (!this.hasAnswers())
      return {};

    let correctAnswers = {};
    for (let answer of this.answer) {
      if(answer.correct)
        correctAnswers[answer.id] = answer;
    }
    return correctAnswers;
  }

  /**
   * Gets LessonAnswer from this 'answer' attr by LessonAnswer id
   * @param {integer} lessonAnswerId
   * @returns {LessonAnswer|Null}
   */
  getAnswerById(lessonAnswerId = null) {
    if (!this.hasAnswers())
      return null;

    for (let answer of this.answer) {
      if(answer.id == lessonAnswerId)
        return answer;
    }

    return null;
  }
}